export default "__VITE_ASSET__CTBYZwxE__"